"use client";
import {
  getAnswer,
  type QuestionnaireAnswers,
  type QuestionnaireField,
} from "@repo/questionnaire";
import { QuestionnaireFieldRenderer } from "./questionnaire-field-renderer";
import dynamic from "next/dynamic";
const QuestionnaireLocationStep = dynamic(() =>
  import("./questionnaire-location-step").then(
    (m) => m.QuestionnaireLocationStep,
  ),
);
import type { QuestionnaireFieldRendererProps } from "./questionnaire-field-renderer-types";

type Props = Omit<
  QuestionnaireFieldRendererProps,
  "field" | "value" | "onChange" | "answers"
> & {
  fields: QuestionnaireField[];
  answers: QuestionnaireAnswers;
  errors: Record<string, string>;
  description?: string | null;
  onChange: (answers: QuestionnaireAnswers, fieldIds?: string[]) => void;
};
export function QuestionnaireStepFields({
  fields,
  answers,
  errors,
  description,
  onChange,
  ...props
}: Props) {
  if (
    fields.length === 3 &&
    fields.every((field) => field.source?.reference === "valuation.location")
  )
    return (
      <QuestionnaireLocationStep
        fields={fields}
        answers={answers}
        errors={errors}
        disabled={props.disabled}
        onChange={onChange}
      />
    );
  return fields.map((field) => (
    <QuestionnaireFieldRenderer
      key={field.id}
      {...props}
      field={field}
      answers={answers}
      value={getAnswer(answers, field.binding)}
      error={errors[field.id]}
      hideLabel={fields.length === 1}
      hideDescription={Boolean(
        description && description === field.description,
      )}
      onChange={(value) => onChange({ [field.binding]: value }, [field.id])}
    />
  ));
}
